export default "__VITE_ASSET__CLVA$Y1s__"